import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import { Button,  Header,  Segment } from "semantic-ui-react";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import { useStore } from "../../../app/stores/store";
import { Link } from "react-router-dom";
import { Formik, Form } from "formik";
import { useField } from "formik";
import * as Yup from 'yup';
import MyTextInput from "../../../app/common/form/MyTextInput";
import {MySelectInput, valor} from "../../../app/common/form/MySelectInput";
import { toast, ToastContainer } from 'react-toastify';
import { Porcentaje } from "../../../app/common/options/Porcentaje";
import { CCTipoDeTransaccion, CCTiposDeTransaccionFormValues } from "../../../app/models/CCTiposDeTransaccion";
import { Select } from 'semantic-ui-react'


export default observer(function CCTipoDeTransaccionForm() {
    const history = useHistory();
    const {CCTiposDeTransaccionStore, modalStore} = useStore();
    

    const {createCCTipoDeTransaccion,
           loading, loadCCTipoDeTransaccion, loadingInitial} = CCTiposDeTransaccionStore;
    const {codigoTipoTransaccion} = useParams<{codigoTipoTransaccion: string}>();


    const [CCTipoDeTransaccion, setCCTipoDeTransaccion] = useState<CCTiposDeTransaccionFormValues>(new CCTiposDeTransaccionFormValues());

    const validationSchema = Yup.object({
        codigoTipoTransaccion: Yup.number().required('Obligatorio'),
        descripcion: Yup.string().required('Obligatorio'),
        operacion: Yup.string().required('Obligatorio'),
        automatica: Yup.string().required('Obligatorio'),
        documentoAmpara: Yup.number().required('Obligatorio'),
        generaComision: Yup.string().required('Obligatorio'),
        porcentaje: Yup.string().required('Obligatorio'),
        valorFijo: Yup.number().required('Obligatorio'),
        operador: Yup.number().required('Obligatorio'),
        tipoDoc: Yup.string().required('Obligatorio'),
        imprimeRecibo: Yup.string().required('Obligatorio')
    })

    useEffect(() => {
        if (codigoTipoTransaccion) loadCCTipoDeTransaccion(codigoTipoTransaccion).then(CCTipoDeTransaccion => setCCTipoDeTransaccion(new CCTiposDeTransaccionFormValues(CCTipoDeTransaccion)))
    }, [codigoTipoTransaccion, loadCCTipoDeTransaccion]);


    function handleFormSubmit(CCTipoDeTransaccion : CCTiposDeTransaccionFormValues) {
        // createCCTipoDeTransaccion(CCTipoDeTransaccion).then(() => history.push(`/CCTTiposDeCuentas/${CCTipoDeTransaccion.codigoTipoTransaccion}`));
        if (CCTipoDeTransaccion.codigoTipoTransaccion) {
            let newCCTipoDeTransaccion:CCTipoDeTransaccion = {
               codigoTipoTransaccion: CCTipoDeTransaccion.codigoTipoTransaccion,
               descripcion: CCTipoDeTransaccion.descripcion,
               operacion: CCTipoDeTransaccion.operacion,
               automatica: CCTipoDeTransaccion.automatica,
               documentoAmpara: CCTipoDeTransaccion.documentoAmpara,
               generaComision: CCTipoDeTransaccion.generaComision,
               porcentaje: CCTipoDeTransaccion.porcentaje,
               valorFijo: CCTipoDeTransaccion.valorFijo,
               operador: CCTipoDeTransaccion.operador,
               tipoDoc: CCTipoDeTransaccion.tipoDoc,
               imprimeRecibo: CCTipoDeTransaccion.imprimeRecibo
           };
        //    createCCTipoDeTransaccion(newCCTipoDeTransaccion).then(() => history.push(`/CCTTiposDeCuentas/${newCCTipoDeTransaccion.codigoTipoTransaccion}`));
            createCCTipoDeTransaccion(newCCTipoDeTransaccion).then(() => {
                toast.success("Se a guardado correctamente")
                modalStore.closeModal()
            });

       }else{
        toast.error("No se puede guardar")}
    }

   if (loadingInitial) return <LoadingComponent content='Cargando...' />

    return (
            <div className="pagina_formulario">
                <Segment className="contenedor_formulario">
                    <Formik validationSchema={validationSchema} 
                            enableReinitialize 
                            initialValues={CCTipoDeTransaccion} 
                            onSubmit={values => handleFormSubmit(values)}>
                        {({handleSubmit, isValid, isSubmitting, dirty}) => (
                            <Form className='ui form' onSubmit={handleSubmit} autoComplete='off'>
                                <Header size='large' content='Tipo de Transaccion' style={{color:  "#538cbe", fontFamily: "Gotham"}} />
                                <br></br>
                                <div style={{marginBottom: "10px"}}>
                                    <Header size="small" content="Codigo de Transaccion" />
                                    <MyTextInput name='codigoTipoTransaccion' placeholder='' />
                                </div>
                                <div>
                                    <Header size="small" content="descripcion" />
                                    <MyTextInput name='descripcion' placeholder='' />
                                </div>
                                <div>
                                    <Header size="small" content="operacion" />
                                    <MyTextInput name='operacion' placeholder='' />
                                </div>
                                <div>
                                    <Header size="small" content="automatica" />
                                    <MyTextInput name='automatica' placeholder='' />
                                </div>
                                <div>
                                    <Header size="small" content="documentoAmpara" />
                                    <MyTextInput name='documentoAmpara' placeholder='' />
                                </div>
                                <div>
                                    <Header size="small" content="generaComision" />
                                    <MyTextInput name='generaComision' placeholder='' />
                                </div>
                                <div>
                                    <Header size="small" content="porcentaje" />
                                    <MySelectInput id="" name='porcentaje' placeholder='' options={Porcentaje} />
                                </div>
                                <div>
                                    <Header size="small" content="valorFijo" />
                                    <MyTextInput name='valorFijo' placeholder='' />
                                </div>
                                <div>
                                    <Header size="small" content="operador" />
                                    <MyTextInput name='operador' placeholder='' />
                                </div>
                                <div>
                                    <Header size="small" content="tipoDoc" />
                                    <MyTextInput name='tipoDoc' placeholder='' />
                                </div>
                                <div>
                                    <Header size="small" content="imprimeRecibo" />
                                    <MyTextInput name='imprimeRecibo' placeholder='' />
                                </div>
                                <br></br>
                                <div>
                                    <Button
                                        loading={loading} 
                                        type='submit' 
                                        content='Guardar' 
                                        style={{backgroundColor: "#15b3e8", color: "white"}}/>
                                </div>
                                {/* <div>
                            <ToastContainer position="bottom-center"
                                autoClose={5000}
                                hideProgressBar={false}
                                newestOnTop={false}
                                closeOnClick
                                rtl={false}
                                pauseOnFocusLoss
                                draggable
                                pauseOnHover />
                        </div> */}
                            </Form>
                        )}
                    </Formik>
                </Segment>
        </div>
    )
})

